import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import ErrorMessage from './components/ErrorMessage'
import LoadingIndicator from './components/LoadingIndicator'
import { Globals, RouteNames } from './utils/constants'

import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

axios.interceptors.request.use(function (config) {
  let token = store.state.accessToken
  let expiresAt = store.state.accessTokenExpiresAt
  let hasExpired = moment(expiresAt).isBefore(moment().subtract(3600, 'second'))

  if (!token || hasExpired) {
    store.commit('clearSession')
    router.push('/login')
    throw new axios.Cancel('Token expired')
  }
  else {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  
  return config
})

Vue.config.productionTip = false
Vue.use(BootstrapVue)

Vue.prototype.$moment = moment
Vue.prototype.$http = axios
Vue.prototype.$routeNames = RouteNames
Vue.prototype.$_ = _

Vue.component('ErrorMessage', ErrorMessage)
Vue.component('LoadingIndicator', LoadingIndicator)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@mdi/font/css/materialdesignicons.min.css'
import './styles/app.scss'
import './styles/switchCheckbox.scss'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
